<script>
	export default {
		onLaunch: function() {
			//console.log(process.env.PROJECT_CONFIG.version);
		},
		onShow: function() {
		},
		onHide: function() {
		}
	}
</script>

<style>
	@import url("@/static/fonts/iconfont.css");
	@import url("@/static/animate.min.css");
	@import url("@/static/main.css");
	@import url("@/static/editor.css");
	
	html,body{
		width:100%;
		height:100%;
		font-size:14px;
		color:#333;
		font-family: 'Source Sans Pro', 'Trebuchet MS', Arial;
		overflow: hidden;
	}
	::-webkit-scrollbar {
	    width: 6px;
	    height: 6px;
	    background-color: rgba(0,0,0,0);
	}
	::-webkit-scrollbar-thumb {
	    /* height: 100px; */
	    border-radius: 10px;
	    background-color: #555;
	}
	::-webkit-scrollbar-track {
	    background-color: rgba(0,0,0,0);
	}
	::selection {
		color:#fff;
	    /* background: rgba(255,255,255,.1); */
	}
	
	page{
		width:100%;
		height:100%;
	}
	button{
		font-size:14px;
	}
	button i{
		margin-right:5px;
	}
	uni-button{
		font-size:14px !important;
	}
	checkbox{
		transform:scale(0.7);
	}
	radio{
		transform:scale(0.7);
	}

	uni-textarea{
		font-size:14px !important;
	}
	textarea{
		font-size:14px !important;
	}
	.uni-radio-input{
		border-radius:0 !important;
	}
	.uni-label-pointer{
		height: 30px;
		line-height: 30px;
		vertical-align: middle;
	}
	
	.animate__animated{
		animation-duration: 0.2s !important;
	}
/* 	.black .uni-checkbox-input {
		background-color:#000 !important;
		border:0 !important;
	} */
	.mask{
		position: fixed;
		left:0;
		right:0;
		top:0;
		bottom:0;
		z-index: 999;
		display:flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		animation-duration: 0.5s;
	}
	/* WF swiper组件前后按钮样式 */
	.swiper-button-next,.swiper-button-prev{
		color:#fff !important;
	}
	.swiper-button-disabled{
		/* color: rgba(0, 0, 0, 0) !important; */
	}
</style>
